import React from "react";
import "../../../../assets/fa-icons/css/fontawesome.css";
import "../../../../assets/fa-icons/css/sharp-regular.css";
import { cn } from "../../../utils/cn.ts";
import { FontStyles } from "../../../utils/font-styles.ts";

interface FloatingHeroItemProps {
  label: string;
  iconName: string;
  mobileLabel?: string;
}

export const FloatingHeroItem: React.FC<FloatingHeroItemProps> = ({ label, iconName, mobileLabel }) => {
  return (
    <div
      className={cn(
        FontStyles["body-md"],
        "px-2 py-1.5 md:px-2.5 md:py-2 flex items-center gap-2 rounded bg-black/50 group-hover:bg-black/75 text-neutral-white",
      )}
    >
      <i className={`fa-sharp fa-regular fa-${iconName}`} aria-hidden="true" />
      {mobileLabel ? (
        <>
          <span className={`!leading-none md:hidden`}>{mobileLabel}</span>
          <span className={`!leading-none hidden md:inline`}>{label}</span>
        </>
      ) : (
        <span className={`!leading-none`}>{label}</span>
      )}
    </div>
  );
};
